import type { RootState } from "../store"

export const selectAdForgeState = (state: RootState) => state.adForge
export const selectAdForgeAds = (state: RootState) => state.adForge.ads
export const selectAdForgeGlobalAdSetIds = (state: RootState) =>
  state.adForge.globalAdSetIds
export const selectAdForgePhase = (state: RootState) => state.adForge.phase
export const selectAdForgeSelectedAssets = (state: RootState) =>
  state.adForge.selectedAssets
export const selectAdForgePickedAssets = (state: RootState) =>
  state.adForge.pickedAssets
export const selectAdForgeSelectedAdSetIds = (state: RootState) =>
  state.adForge.selectedAdSetIds
export const selectAdForgeSelectedAdSetsData = (state: RootState) =>
  state.adForge.selectedAdSetsData
export const selectAdForgeDestinationOverrides = (state: RootState) =>
  state.adForge.destinationOverrides
export const selectAdForgePrefillCreative = (state: RootState) =>
  state.adForge.prefillCreative
export const selectAdForgeSourceAd = (state: RootState) =>
  state.adForge.sourceAd

export const selectAdForgePendingAiAction = (state: RootState) =>
  state.adForge.pendingAiAction

export const selectAdForgeProductContext = (state: RootState) =>
  state.adForge.productContext
